import { render, staticRenderFns } from "./LinkPopup.vue?vue&type=template&id=117ac844&scoped=true"
import script from "./LinkPopup.vue?vue&type=script&lang=js"
export * from "./LinkPopup.vue?vue&type=script&lang=js"
import style0 from "./LinkPopup.vue?vue&type=style&index=0&id=117ac844&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ac844",
  null
  
)

export default component.exports